import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'
import './man-con.css'

import { Personnel, defaultValues as PersonnelValues } from './personnel'
import { PreviousHistory, defaultValues as PreviousHistoryValues } from './previous-history'
import { Declarations, defaultValues as DeclarationsValues } from './declarations'
import {
  OperationOfService,
  defaultValues as OperationOfServiceValues,
} from './operation-of-service'
import {
  EmployedInAService,
  defaultValues as EmployedInAServiceValues,
} from './employed-in-a-service'
import { OtherService, defaultValues as OtherServiceValues } from './other-service'

export const defaultValues = Object.assign(
  {},
  PersonnelValues,
  OperationOfServiceValues,
  EmployedInAServiceValues,
  OtherServiceValues,
  PreviousHistoryValues,
  DeclarationsValues
)

export const RegisterManConForm = formProps => (
  <Fragment>
    <Heading small>Register new Management & Control Personnel</Heading>

    <Personnel {...formProps} />
    <OperationOfService {...formProps} />
    <EmployedInAService {...formProps} />
    <OtherService {...formProps} />
    <PreviousHistory {...formProps} />
    <Declarations {...formProps} />
  </Fragment>
)

export default RegisterManConForm



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/index.js